export default __webpack_public_path__ + "static/media/89.10ce6f89.png";